import EditMemberInfo from './EditMemberInfo';
export default EditMemberInfo;
